import {
  IWaitingRoom,
  WaitingRoomConditionType,
} from "src/Pages/Company/Pending/PendingBenefits/types";

export const moveChildrenUnderParents = (waitingRooms: IWaitingRoom[]) => {
  const parentIdsWithNewPrice = new Set<string>(
    waitingRooms
      .filter(
        (room) =>
          !room.parentWaitingRoomId &&
          room.conditions.some(
            (c) => c.type === WaitingRoomConditionType.NEW_PRICE
          )
      )
      .map((room) => room.id)
  );

  const childrenByParentId = new Map<string, IWaitingRoom[]>();
  waitingRooms.forEach((room) => {
    if (
      room.parentWaitingRoomId &&
      parentIdsWithNewPrice.has(room.parentWaitingRoomId)
    ) {
      if (!childrenByParentId.has(room.parentWaitingRoomId)) {
        childrenByParentId.set(room.parentWaitingRoomId, []);
      }
      childrenByParentId.get(room.parentWaitingRoomId)!.push(room);
    }
  });

  const result: IWaitingRoom[] = [];
  waitingRooms.forEach((room) => {
    if (
      room.parentWaitingRoomId != null &&
      parentIdsWithNewPrice.has(room.parentWaitingRoomId)
    ) {
      return;
    }
    result.push(room);
    if (parentIdsWithNewPrice.has(room.id)) {
      result.push(...(childrenByParentId.get(room.id) ?? []));
    }
  });

  return result;
};
